import { Fragment } from 'react';
import { Label, Spacer, Cell, Text, Icon, Card, Modal, Radio, Button, Divider } from '@vinted/web-ui';
import { FormattedMessage } from 'components/@support';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const LanguageSelectorModal = _ref => {
  let {
    languages,
    activeLanguage,
    selectedLanguage,
    isMenuOpen,
    isStandalone,
    onLanguageMenuToggle,
    onLanguageSelect,
    saveLanguageSelection
  } = _ref;

  const handleLanguageSelect = language => () => onLanguageSelect(language);

  const handleLanguageSubmit = language => () => saveLanguageSelection(language);

  const renderNavigationToggle = () => /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Label, {
      type: Label.Type.Stacked,
      styling: Label.Styling.Default,
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        id: "language_selector.menu_title"
      })
    }), /*#__PURE__*/_jsxs(Cell, {
      prefix: /*#__PURE__*/_jsx(Icon, {
        name: "globe",
        color: Icon.Color.Gray3_v2
      }),
      type: Cell.Type.Navigating,
      onClick: onLanguageMenuToggle,
      children: [/*#__PURE__*/_jsx(Text, {
        text: activeLanguage.title_local,
        type: Text.Type.Subtitle,
        theme: "amplified"
      }), /*#__PURE__*/_jsx(Spacer, {
        orientation: Spacer.Orientation.Vertical,
        size: Spacer.Size.Small
      }), /*#__PURE__*/_jsx(Text, {
        text: "(".concat(activeLanguage.title, ")"),
        type: Text.Type.Subtitle,
        theme: "muted"
      })]
    })]
  });

  const renderStandaloneToggle = () => /*#__PURE__*/_jsx("div", {
    className: "u-ui-padding-left-small",
    children: /*#__PURE__*/_jsx(Button, {
      text: activeLanguage.title_short.toUpperCase(),
      styling: Button.Styling.Flat,
      size: Button.Size.Medium,
      theme: "muted",
      inline: true,
      truncated: false,
      icon: /*#__PURE__*/_jsx(Icon, {
        name: "dropdown",
        size: Icon.Size.Small,
        color: Icon.Color.Gray3_v2
      }),
      iconPosition: Button.IconPosition.Right,
      onClick: onLanguageMenuToggle
    })
  });

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isStandalone ? renderStandaloneToggle() : renderNavigationToggle(), /*#__PURE__*/_jsx(Modal, {
      show: isMenuOpen,
      children: /*#__PURE__*/_jsxs(Card, {
        styling: Card.Styling.Elevated,
        children: [/*#__PURE__*/_jsx(Cell, {
          children: /*#__PURE__*/_jsx("div", {
            className: "u-text-center",
            children: /*#__PURE__*/_jsx(Text, {
              text: /*#__PURE__*/_jsx(FormattedMessage, {
                id: "language_selector.menu_title"
              }),
              type: Text.Type.Heading
            })
          })
        }), languages.map(language => {
          const isChecked = language.id === selectedLanguage.id;
          return /*#__PURE__*/_jsxs(Fragment, {
            children: [/*#__PURE__*/_jsxs(Cell, {
              type: Cell.Type.Navigating,
              onClick: handleLanguageSelect(language),
              suffix: /*#__PURE__*/_jsx(Radio, {
                name: "language_selector_".concat(language.id),
                checked: isChecked
              }),
              children: [/*#__PURE__*/_jsx(Text, {
                text: language.title_local,
                theme: "amplified",
                bold: true
              }), /*#__PURE__*/_jsx(Spacer, {
                orientation: Spacer.Orientation.Vertical,
                size: Spacer.Size.Small
              }), /*#__PURE__*/_jsx(Text, {
                text: "(".concat(language.title, ")"),
                bold: true
              })]
            }), /*#__PURE__*/_jsx(Divider, {})]
          }, language.id);
        }), /*#__PURE__*/_jsx("div", {
          className: "u-ui-padding-large",
          children: /*#__PURE__*/_jsx(Button, {
            text: /*#__PURE__*/_jsx(FormattedMessage, {
              id: "language_selector.menu_options.save"
            }),
            styling: Button.Styling.Filled,
            onClick: handleLanguageSubmit(selectedLanguage),
            testId: "language-selector-modal-save"
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "u-ui-padding-large u-padding-top-none",
          children: /*#__PURE__*/_jsx(Button, {
            text: /*#__PURE__*/_jsx(FormattedMessage, {
              id: "language_selector.menu_options.cancel"
            }),
            styling: Button.Styling.Flat,
            onClick: onLanguageMenuToggle,
            testId: "language-selector-modal-cancel"
          })
        })]
      })
    })]
  });
};

export default LanguageSelectorModal;